export default "__VITE_ASSET__DJTQEqgG__"